import NavigationMenuBar from './NavigationMenuBar'

export default NavigationMenuBar
